import { useContext } from 'react';

import { SubscriptionContext } from './subscription-context';

export const useSubscription = () => {
  return useContext(SubscriptionContext);
};
